import React from "react";

const InfoIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M7.5 1.25C10.9519 1.25 13.75 4.04813 13.75 7.5C13.7513 9.14092 13.1072 10.7165 11.9568 11.8867C10.8064 13.0568 9.24197 13.7275 7.60126 13.7541C5.96056 13.7807 4.37521 13.161 3.1875 12.0288C1.99979 10.8965 1.30499 9.3426 1.25313 7.7025L1.25 7.5L1.2525 7.325C1.345 3.95438 4.10625 1.25 7.5 1.25ZM7.5 6.875H6.875L6.80188 6.87937C6.64997 6.89744 6.50996 6.9706 6.40838 7.08498C6.3068 7.19936 6.2507 7.34702 6.2507 7.5C6.2507 7.65298 6.3068 7.80064 6.40838 7.91502C6.50996 8.0294 6.64997 8.10256 6.80188 8.12063L6.875 8.125V10L6.87937 10.0731C6.89583 10.2126 6.9588 10.3425 7.05813 10.4419C7.15746 10.5412 7.28736 10.6042 7.42688 10.6206L7.5 10.625H8.125L8.19812 10.6206C8.33764 10.6042 8.46754 10.5412 8.56687 10.4419C8.6662 10.3425 8.72917 10.2126 8.74563 10.0731L8.75 10L8.74563 9.92688C8.73068 9.79936 8.67684 9.67954 8.5914 9.58371C8.50597 9.48787 8.39309 9.42068 8.26813 9.39125L8.19812 9.37875L8.125 9.375V7.5L8.12063 7.42688C8.10417 7.28736 8.0412 7.15746 7.94187 7.05813C7.84254 6.9588 7.71264 6.89583 7.57312 6.87937L7.5 6.875ZM7.50625 5L7.42688 5.00437C7.27497 5.02244 7.13496 5.0956 7.03338 5.20998C6.9318 5.32436 6.8757 5.47202 6.8757 5.625C6.8757 5.77798 6.9318 5.92564 7.03338 6.04002C7.13496 6.1544 7.27497 6.22756 7.42688 6.24563L7.5 6.25L7.57937 6.24563C7.73128 6.22756 7.87128 6.1544 7.97287 6.04002C8.07445 5.92564 8.13055 5.77798 8.13055 5.625C8.13055 5.47202 8.07445 5.32436 7.97287 5.20998C7.87128 5.0956 7.73128 5.02244 7.57937 5.00437L7.50625 5Z"
        fill="#00A759"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default InfoIcon;
